import {
	ACCOUNT_LINK_SET_STEP,
	ACCOUNT_LINK_STORE_DATA,
	ACCOUNT_LINK_GET_MANAGER_BY_CPF_STARTED,
	ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED,
	ACCOUNT_LINK_GET_RELATIONSHIP_STARTED,
	ACCOUNT_LINK_GET_RELATIONSHIP_FINISHED,
	ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_STARTED,
	ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_FINISHED,
	ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_STARTED,
	ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_FINISHED,
	ACCOUNT_LINK_SEARCH_MANAGER_BY_CPF_CLEAN,
	ACCOUNT_LINK_IF_RENDER_MODAL_INVALID_CPF,
	ACCOUNT_LINK_PARTICIPANT_SENDING_FILE
} from "../shared/constants";
import {
	getManagerByCPF,
	getParticipantRelationships,
	participantApproveInvite,
	participantCancelRelationship
} from "../shared/multi-accounts-requests-api";
import R from "ramda";

export const getRelationshipsParticipant = () => {
	return function(dispatch) {
		dispatch({
			type: ACCOUNT_LINK_GET_RELATIONSHIP_STARTED
		});

		getParticipantRelationships().then(response => {
			// Ordenação do mais recente pro mais antigo
			let sorted = R.sortWith([R.descend(R.path(["dateUpdated"]))]);
			let data = response.data.map(relationship => {
				relationship.dateUpdated = new Date(relationship.updated);
				return relationship;
			});
			data = sorted(data);

			let badgeCountPendent = 0;

			// Procura relationships novas que estão pendente de ação do usuário (apenas primeira vez)
			if (data && data.length) {
				for (let i = 0; i < data.length; i++) {
					let relationship = data[i];

					if (relationship.status.subStatus === "inviteSendParticipant") {
						badgeCountPendent++;
					}
				}
			}

			dispatch({
				type: ACCOUNT_LINK_GET_RELATIONSHIP_FINISHED,
				payload: {
					dataRelationshipParticipant: data,
					dataCurrentStepParticipant: response.data.length === 0 ? 5 : 1,
					badgeCountPendent
				}
			});
		});
	};
};

export const onCancelRelationshipParticipant = (data, callback) => {
	return function(dispatch) {
		dispatch({
			type: ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_STARTED,
			payload: data.relationId
		});

		participantCancelRelationship(data).then(
			response => {
				if (window.newOfferContext) {
					window.newOfferContext.fetchParticipantData();
				}
				
				dispatch({
					type: ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_FINISHED
				});
				dispatch(getRelationshipsParticipant());
				if (callback) {
					callback();
				}
			},
			error => {
				dispatch({
					type: ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_FINISHED
				});
				dispatch(getRelationshipsParticipant());
				if (callback) {
					callback();
				}
			}
		);
	};
};

export const onApproveInvite = data => {
	return function(dispatch) {
		dispatch({
			type: ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_STARTED
		});

		participantApproveInvite(data).then(response => {
			return dispatch({
				type: ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_FINISHED,
				payload: {
					isApproveSuccess: true
				}
			});
		});
	};
};

export const onSendingFile = value => {
	return function(dispatch) {
		dispatch({
			type: ACCOUNT_LINK_PARTICIPANT_SENDING_FILE,
			payload: {
				sendingFile: value
			}
		});
	};
};

export const onSearchByCPFParticipant = (dataCPF, relationshipId) => {
	return function(dispatch) {
		dispatch({
			type: ACCOUNT_LINK_GET_MANAGER_BY_CPF_STARTED
		});

		getManagerByCPF(dataCPF, relationshipId).then(response => {
			if (response.data.name) {
				return dispatch({
					type: ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED,
					payload: {
						dataApproveInvite: response.data,
						isInvalidCPF: false,
						isFailureLimitReached: false,
						renderModalInvalidCPF: false,
						isOneLessAttempt: false
					}
				});
			}

			// Errou uma vez
			if (response.data.countFailure === 1) {
				return dispatch({
					type: ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED,
					payload: {
						isInvalidCPF: true,
						isFailureLimitReached: false,
						renderModalInvalidCPF: false,
						isOneLessAttempt: false
					}
				});
			}

			// Errou a segunda vez
			if (response.data.countFailure === 2) {
				return dispatch({
					type: ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED,
					payload: {
						isInvalidCPF: true,
						isFailureLimitReached: false,
						renderModalInvalidCPF: true,
						isOneLessAttempt: true
					}
				});
			}

			// Errou a terceira vez
			if (response.data.countFailure > 2) {
				dispatch(getRelationshipsParticipant());
				return dispatch({
					type: ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED,
					payload: {
						isInvalidCPF: true,
						isFailureLimitReached: true,
						renderModalInvalidCPF: false,
						isOneLessAttempt: false
					}
				});
			}

			return dispatch({
				type: ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED,
				payload: {}
			});
		});
	};
};

export const ifRenderModalInvalidCPF = () => {
	return function(dispatch) {
		dispatch({
			type: ACCOUNT_LINK_IF_RENDER_MODAL_INVALID_CPF,
			payload: {
				renderModalInvalidCPF: false
			}
		});
	};
};

export const cleanSearchManagerByCpf = () => {
	return function(dispatch) {
		dispatch({
			type: ACCOUNT_LINK_SEARCH_MANAGER_BY_CPF_CLEAN
		});
	};
};

export const setStepParticipant = step => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});

	return {
		type: ACCOUNT_LINK_SET_STEP,
		payload: step
	};
};

export const setDataToStoreParticipant = data => {
	return {
		type: ACCOUNT_LINK_STORE_DATA,
		payload: data
	};
};
